import React, { memo } from "react";
import { DataTable, SearchPropTypes } from "MODULES/shared/components";
import { displayDecimal } from "LIB/formatters/number";
import PartLink from "MODULES/Notifications/components/Search/PartLink";

const Table = memo(({ results = [], isLoading, refresh }) => (
  <DataTable loading={isLoading} loadingRows={3} refresh={refresh}>
    <DataTable.Head>
      <th>Part</th>
      <th>Desc</th>
      <th>Sellable Qty</th>
      <th>Stat</th>
    </DataTable.Head>
    <DataTable.Body>
      {results.map(r => (
        <tr>
          <td>
            <PartLink
              uuid={r.part_uuid}
              tierType={r.part_tier_type}
              partNumber={r.part_number}
            />
          </td>
          <td>{r.part_description}</td>
          <td>{r.sellable_quantity}</td>
          <td>{displayDecimal(r.stat, 2)}</td>
        </tr>
      ))}
    </DataTable.Body>
  </DataTable>
));

Table.propTypes = {
  ...SearchPropTypes
};

export default Table;



// WEBPACK FOOTER //
// ./app/modules/Admin/PartRankings/Table.jsx